module.exports = __webpack_public_path__ + "static/media/Filipa_Ferreira.9ee8abd6.jpg";